/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ShiftLvlDto {
  lvl: number;
  /**
   * Formula: \"1 = 0.1 BPS = 0.001% = 0.00001\". Moves mid price up or down for specified BPS.
   */
  shortPosition: number;
  /**
   * Formula: \"1 = 0.1 BPS = 0.001% = 0.00001\". Moves mid price up or down for specified BPS.
   */
  longPosition: number;
}
